import { Navigate } from 'react-router-dom';

export default function ExpensesPage() {
  return <Navigate to="/transactions" replace />;
}
